import {HEADER_TEXT_CODES, TEST_TYPES} from "../../../utils/constants";
import {Emphasized, Italics, OtherPresent} from "../HeaderCellTypes";

export const PrintCell = (attributeInfo, sample) => {
	const attributeValue = sample[attributeInfo.name]
	
	if((attributeInfo.name === 'binary_nsg' || attributeInfo.name === 'bulk_staph_aureus' || attributeInfo.name === 'component_fat') && sample.test_type.includes(TEST_TYPES.lost_in_transit)){
		return TEST_TYPES.lost_in_transit
	}
	
	if(attributeInfo.partOfTests.length === 0){
		return attributeInfo.format(attributeValue)
	}
	
	let testTypeIndex = 0
	
	for(testTypeIndex; testTypeIndex < attributeInfo.partOfTests.length; testTypeIndex++) {
		if (sample.test_type.includes(attributeInfo.partOfTests[testTypeIndex])) {
			return attributeInfo.format(attributeValue)
		}
	}
	
	return ''
}

export const FormatHeaderText = (text) => {
	switch(text.charAt(0)){
		case HEADER_TEXT_CODES.EMPHASIZE:
			return <Emphasized text={text.slice(1)}/>
		case HEADER_TEXT_CODES.ITALICS:
			return <Italics text={text.slice(1)}/>
		case HEADER_TEXT_CODES.OTHER_PRESENT:
			return <OtherPresent text={text.slice(1, text.indexOf(' '))}/>
		default:
			return text
	}
}

export const TestValueToString = (boolTestResult, falseIsMinus = false) => {
	return boolTestResult === null ? "Pend." : (
		boolTestResult ? "+" : falseIsMinus ? "-" : " "
	)
}

export const NSGToString = nsgValue => (
	nsgValue === null ? '' : nsgValue ? 'X' : ''
)

export const CommaSeperateNumber = input => {
	if(!input){return ''}
	
	let cleanInput = input.replaceAll(/(,|\s)/g, '')
	
	let matchDigits = /\d/g
	let matchNonDigits = /\D/g
	
	let numbers = cleanInput.match(matchDigits)
	
	if(!numbers){
		return cleanInput
	}
	
	let commaNumber = ''
	
	let allZerosCheck = true
	let nonZeroSeen = false
	
	for(let i = 0; i < numbers.length; i++){
		if(numbers[i] !== "0"){
			nonZeroSeen = true
		}
		
		if(!nonZeroSeen){
			numbers = numbers.splice(i, 1)
		}
	}
	
	for(let i = numbers.length-1; i >= 0; i--){
		if(commaNumber.length !== 0 && commaNumber.replaceAll(',', '').length % 3 === 0){
			commaNumber = ',' + commaNumber
		}
		
		commaNumber = numbers[i] + commaNumber
	}
	
	let nonNumbers = cleanInput.match(matchNonDigits)
	
	if(!nonNumbers){
		return commaNumber
	}
	
	let preNumChars = ''
	let postNumChars = ''
	
	for(let i = 0; i < nonNumbers.length; i++){
		let nonNumChar = nonNumbers[i]
		
		if(cleanInput.indexOf(nonNumChar) < cleanInput.indexOf(numbers[0])){
			preNumChars += nonNumChar
		}else{
			postNumChars += nonNumChar
		}
	}
	
	commaNumber = preNumChars + commaNumber + postNumChars
	
	return commaNumber
}

export const CommaSafeCSVString = value => (
	`"${value === null ? '' : value}"`
)